import { useState, type FormEvent } from "react";
import { ArrowRight, Boxes, LoaderCircle, LockKeyhole } from "lucide-react";

interface LoginProps {
  onLogin: (email: string, password: string) => Promise<void>;
}

export function Login({ onLogin }: LoginProps) {
  const [email, setEmail] = useState("joao.escherr@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await onLogin(email, password);
    } catch {
      setError("E-mail ou senha inválidos.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-screen">
      <section className="login-panel" aria-labelledby="login-title">
        <div className="brand-lockup brand-lockup--login">
          <span className="brand-mark" aria-hidden="true"><Boxes size={20} /></span>
          <span>Go Win Pro</span>
        </div>
        <div className="login-copy">
          <p className="eyebrow">Agent Studio</p>
          <h1 id="login-title">Central de orquestração</h1>
          <p>Entre para construir, executar e acompanhar suas equipes de agentes.</p>
        </div>
        <form className="login-form" onSubmit={submit}>
          <label>
            <span>E-mail</span>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />
          </label>
          <label>
            <span>Senha</span>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
              autoFocus
            />
          </label>
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="button button--primary button--wide" type="submit" disabled={loading}>
            {loading ? <LoaderCircle className="spin" size={16} /> : <LockKeyhole size={16} />}
            Entrar
            {!loading && <ArrowRight size={16} />}
          </button>
        </form>
        <div className="login-status"><span className="status-dot status-dot--ok" /> Ambiente privado</div>
      </section>
      <aside className="login-stage" aria-hidden="true">
        <div className="stage-grid" />
        <div className="stage-node stage-node--one"><span />Entrada</div>
        <div className="stage-node stage-node--two"><span />Orquestrador</div>
        <div className="stage-node stage-node--three"><span />Equipe</div>
        <svg className="stage-links" viewBox="0 0 720 720" preserveAspectRatio="none">
          <path d="M130 370 C230 370, 240 270, 345 270" />
          <path d="M450 270 C540 270, 520 390, 620 390" />
        </svg>
      </aside>
    </main>
  );
}
